class ProviderDetails{
  id:string
  name:string
}

export class RuleModel{
  _id?:string
  name:string;
  customApplicationAccess:boolean;
  applications:Array<any>;
  identityProvider:ProviderDetails
  clientId:string
  isActive?:boolean
  hasDefaultRole:boolean
}
